module.exports = __webpack_public_path__ + "static/img/videoInit.1c70a26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/videoInit.png
// module id = 25
// module chunks = 49